(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("bluebird"), require("underscore"), require("@bingads-webui-universal/primitive-utilities"), require("@bingads-webui/safe-json"), require("@bingads-webui/url-util"), require("jquery"));
	else if(typeof define === 'function' && define.amd)
		define(["bluebird", "underscore", "@bingads-webui-universal/primitive-utilities", "@bingads-webui/safe-json", "@bingads-webui/url-util", "jquery"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("bluebird"), require("underscore"), require("@bingads-webui-universal/primitive-utilities"), require("@bingads-webui/safe-json"), require("@bingads-webui/url-util"), require("jquery")) : factory(root["bluebird"], root["underscore"], root["@bingads-webui-universal/primitive-utilities"], root["@bingads-webui/safe-json"], root["@bingads-webui/url-util"], root["jquery"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})((typeof self !== 'undefined' ? self : this), function(__WEBPACK_EXTERNAL_MODULE__6__, __WEBPACK_EXTERNAL_MODULE__7__, __WEBPACK_EXTERNAL_MODULE__8__, __WEBPACK_EXTERNAL_MODULE__13__, __WEBPACK_EXTERNAL_MODULE__42__, __WEBPACK_EXTERNAL_MODULE__99__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 95);
/******/ })
/************************************************************************/
/******/ ({

/***/ 100:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.host = host;
exports.path = path;
exports.fill = fill;
exports.expand = expand;
exports.make = make;
exports.queryify = queryify;
exports.getDomain = getDomain;
exports.getProtocol = getProtocol;
exports.getPort = getPort;

var _underscore = _interopRequireDefault(__webpack_require__(7));

var $url = _interopRequireWildcard(__webpack_require__(42));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function host(options) {
  return options.host; // NOFIX:
  // return config.has(options.host)? config.get(options.host) : options.host;
}

function path(options) {
  return options.path; // NOFIX:
  // return config.has(options.path)? config.get(options.path) : options.path;
}

function fill(url, options) {
  if (options === void 0) {
    options = {};
  }

  var ret = url;
  var params = {}; // NOFIX:
  // if (options.use_state !== false) {
  //   params = state.attributes;
  // }

  if (options.params) {
    params = _underscore.default.extend({}, params, options.params);
  } // try to replace with value from params; otherwise keep as original


  ret = url.replace(/:([a-zA-Z_]+)/g, function (match, key) {
    return _underscore.default.has(params, key) ? params[key] : match;
  });
  return ret;
}

function expand(url, options) {
  if (options === void 0) {
    options = {};
  }

  var ret = url;

  var expandOptions = _underscore.default.defaults(options, {
    composeBatchUrl: true
  });

  if (expandOptions.composeBatchUrl && expandOptions.host && !new RegExp("^".concat(host(expandOptions))).test(ret)) {
    ret = $url.join(host(expandOptions) || '', path(expandOptions) || '', ret);
  } // replace all param placeholders by backbone style slugs
  // ex: /Customers()/Accounts()/ becomes /Customers(:customer_id)/Accounts(:account_id)/


  ret = ret.replace(/\/((\w+?)s?)(\(\))/g, function (match, col, type) {
    return "/".concat(col, "(:").concat(type.toLowerCase(), "_id)");
  });
  return ret;
}

function make(url, options) {
  return fill(expand(url, options), options);
}

function queryify(url, _a) {
  var method = _a.method,
      data = _a.data,
      customParamSerialize = _a.customParamSerialize,
      urlParameters = _a.urlParameters;
  var isGet = !method || method === 'GET';

  if (isGet && _underscore.default.isObject(data)) {
    // $.param is not supported by node, so use custom param serialization function
    return $url.queryify(url, data, customParamSerialize);
  }

  var isPostOrPatch = !method || method === 'POST' || method === 'PATCH';

  if (isPostOrPatch && _underscore.default.isObject(urlParameters)) {
    // $.param is not supported by node, so use custom param serialization function
    return $url.queryify(url, urlParameters, customParamSerialize);
  }

  return url;
}

function getDomain() {
  return document.domain;
}

function getProtocol() {
  return window.location.protocol;
}

function getPort() {
  return window.location.port;
}

/***/ }),

/***/ 101:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ajax;

var _underscore = _interopRequireDefault(__webpack_require__(7));

var putil = _interopRequireWildcard(__webpack_require__(8));

var core = _interopRequireWildcard(__webpack_require__(98));

var urlUtil = _interopRequireWildcard(__webpack_require__(100));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ajax() {
  var args = [];

  for (var _i = 0; _i < arguments.length; _i++) {
    args[_i] = arguments[_i];
  }

  var _a = core.signature(args),
      url = _a[0],
      options = _a[1],
      cb = _a[2]; // NOFIX:
  // if (!options.host) {
  //   options.host = 'odata.url';
  // }
  // if (!options.path) {
  //   options.path = 'odata.path';
  // }


  var uri = urlUtil.make(url, {
    host: options.host,
    path: options.path,
    // NOFIX:
    // use_state: options.use_state,
    params: options.params
  });
  options.beforeSend = _underscore.default.wrap(options.beforeSend || _underscore.default.noop, function (func, jqXHR) {
    // All these setRequestHeader logic could be handled by `options.headers`
    // These code and related options are deprecated
    // NOFIX:
    // var oDataToken = config.get('odata.token');
    // NOTICE: oDataToken changed to come from options
    var oDataToken = options.oDataToken,
        oDataTokenType = options.oDataTokenType;

    if (oDataToken) {
      var tokenType = oDataTokenType || 'CCMTSmallToken';
      jqXHR.setRequestHeader('Authorization', "".concat(tokenType, " ").concat(oDataToken));
    } // NOFIX:
    // var loginType = config.get('odata.loginType');
    // NOTICE: loginType changed to come from options


    var loginType = options.loginType;

    if (loginType) {
      jqXHR.setRequestHeader('x-ms-logintype', loginType);
    } // enable odata annotations by default;
    // we use annotations to return aggregates in grid responses


    jqXHR.setRequestHeader('Prefer', 'odata.include-annotations="*"');
    var requestId = putil.generateGuid();
    jqXHR.setRequestHeader('x-ms-requestid', requestId);
    var applicationName = options.applicationName;
    jqXHR.setRequestHeader('x-ms-applicationname', applicationName || 'bingadsweb');
    var headers = options.headers; // NOFIX:
    // var sessionId = _.result(config.get('Omniture'), 'SessionId');
    // JFX_SessionId is a secure HttpOnly cookie, inaccessible to client side cookie.
    // Changed from cookie to come from options.

    var sessionId = options.SessionId;

    if (!_underscore.default.isUndefined(sessionId)) {
      jqXHR.setRequestHeader('x-ms-sessionid', sessionId);
    } else if (headers && headers['x-ms-sessionid']) {
      jqXHR.setRequestHeader('x-ms-sessionid', headers['x-ms-sessionid']);
    } // NOFIX:
    // We could pass in all these from `options.headers`
    // var pageContext = config.attributes();
    // if (!_.isUndefined(pageContext)) {
    //   jqXHR.setRequestHeader('x-ms-lcid', pageContext.CultureLcid);
    //   jqXHR.setRequestHeader('lcid', pageContext.CultureLcid);
    // }


    if (options.customHeader) {
      jqXHR.setRequestHeader(options.customHeader.name, options.customHeader.value);
    } // call the original func we are wrapping here


    if (_underscore.default.isFunction(func)) {
      return func(jqXHR);
    }
  });

  options.parse = function (err) {
    return err.value;
  }; // TODO: this logic is specific to Campaign OData


  options.i18nErrors = function (errs, i18n) {
    if (errs) {
      return _underscore.default.map(errs, function (err) {
        var key = "Error_Campaign_API_".concat(err.Code);

        if (err['@odata.type'] === '#Model.ApiEditorialError') {
          key = "Error_Editorial_Raw_".concat(err.Code);
        }

        return i18n.getStringOrDefault(key, i18n.getString('Error: ') + err.Code);
      });
    }

    return [];
  };

  if (_underscore.default.isUndefined(options.contentType)) {
    options.contentType = 'application/json';
  }

  return core.ajax(uri, options, cb);
}

/***/ }),

/***/ 102:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = batch;

var putil = _interopRequireWildcard(__webpack_require__(8));

var _odataCore = _interopRequireDefault(__webpack_require__(101));

var multipart = _interopRequireWildcard(__webpack_require__(103));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function batch(options, cb) {
  var boundary = putil.generateGuid(); // NOFIX:
  // const url = config.get('odata.batch_url');

  var url = options.batchURL; // NOFIX:
  // if (!options.host) {
  //   options.host = 'odata.url';
  // }
  // if (!options.path) {
  //   options.path = 'odata.path';
  // }

  return (0, _odataCore.default)(url, {
    method: 'POST',
    data: multipart.generate(options, boundary),
    contentType: "multipart/mixed; boundary=\"".concat(boundary, "\""),
    dataType: 'text',
    host: options.host,
    path: options.path,
    headers: options.headers // NOTICE: oDataToken, loginType, SessionId are deprecated, use headers

  }, function (err, response, textStatus, xhr) {
    var res = err ? [] : multipart.parse(response);

    if (cb) {
      cb(err, res, textStatus, xhr);
    }
  }).then(multipart.parse);
}

/***/ }),

/***/ 103:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generate = generate;
exports.parse = parse;

var _underscore = _interopRequireDefault(__webpack_require__(7));

var safeJSON = _interopRequireWildcard(__webpack_require__(13));

var urlUtil = _interopRequireWildcard(__webpack_require__(100));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function generate(options, boundary) {
  var lines = [];

  _underscore.default.each(options.reqs, function (req) {
    var method = req.type.toUpperCase();
    var url = urlUtil.make(req.url, _underscore.default.extend(options, {
      // NOFIX:
      // path: 'odata.multipart_path',
      path: options.multipartPath
    }));
    lines.push("--".concat(boundary)); // [imang]: the content-type and content-transfer-encoding headers
    // must be present for delete reqs inside a batch call

    if (method !== 'GET' || options.needContentType
    /* && method != 'DELETE' */
    ) {
        lines.push("Content-Type: ".concat(req.contentType || 'application/http'));
        lines.push("Content-Transfer-Encoding: ".concat(req.contentTransferEncoding || 'binary'));
      }

    lines.push('', "".concat(method, " ").concat(url, " HTTP/1.1")); // req.headers is used to support all kinds of data headers of every request in batch call body

    if (!_underscore.default.isUndefined(req.headers)) {
      // the following is meant to ingnore the specific headers which are already supported by req.dataContentType
      // and options.authorization.
      // for any other headers, please use req.headers. don't add another specific option to support.
      var ignored_1 = [];

      if (!_underscore.default.isNull(req.data) && !_underscore.default.isUndefined(req.data)) {
        ignored_1.push('Content-Type');

        if (options.authorization) {
          ignored_1.push('Authorization');
        }
      }

      _underscore.default.each(req.headers, function (value, key) {
        if (ignored_1.indexOf(key) == -1) {
          lines.push("".concat(key, ": ").concat(value));
        }
      });
    }

    if (!_underscore.default.isNull(req.data) && !_underscore.default.isUndefined(req.data)) {
      lines.push("Content-Type: ".concat(req.dataContentType || 'application/json; charset=utf-8'));

      if (options.authorization) {
        lines.push("Authorization: ".concat(options.authorization));
      }

      lines.push('', JSON.stringify(req.data));
    }

    lines.push('\r\n');
  });

  if (lines.length) {
    lines.push("--".concat(boundary, "--"), '');
  }

  return lines.join('\r\n');
}

function parseHttpResponse(responseString) {
  var lines = responseString.split(/\r?\n/);
  var statusLine = lines.shift(); // parse header lines

  var headers = {};
  var headerParts;
  var headerLine;
  var key;

  while (lines.length > 0) {
    headerLine = lines.shift();

    if (headerLine === '') {
      break;
    }

    headerParts = headerLine.split(':');
    key = headerParts.shift();
    headers[key] = headerParts.join(':').trim();
  }

  var response = {
    headers: headers,
    data: safeJSON.parseSync(lines.join(''))
  }; // parse status line

  var parts = statusLine.match(/^(.+) ([0-9]{3}) (.*)$/);

  if (parts) {
    var protocol = parts[1],
        status_1 = parts[2],
        statusMessage = parts[3];
    response.protocol = protocol;
    response.status = parseInt(status_1, 10);
    response.statusMessage = statusMessage;
  }

  return response;
}

function parse(text) {
  if (text === void 0) {
    text = '';
  }

  var lines = text.split('\r\n');
  var boundary = lines[0];
  var responses = [];
  var tmp;
  var scanStatus = 0;

  _underscore.default.each(lines, function (line) {
    if (line.indexOf(boundary) === 0) {
      if (scanStatus === 2) {
        responses.push(parseHttpResponse(tmp.join('\r\n')));
      } // a new response begin


      scanStatus = 1;
      tmp = [];
    } else if (scanStatus === 1 && line === '') {
      // real response begin
      scanStatus = 2;
    } else if (scanStatus === 2) {
      tmp.push(line);
    }
  });

  var successCodeList = [200, 204];

  var statusCounter = _underscore.default.chain(responses).countBy(function (val) {
    return _underscore.default.contains(successCodeList, val.status) ? 'success' : 'failure';
  }).defaults({
    success: 0,
    failure: 0
  }).value();

  Object.defineProperty(responses, 'statusCounter', {
    value: statusCounter,
    enumerable: false
  });
  return responses;
}

/***/ }),

/***/ 13:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__13__;

/***/ }),

/***/ 42:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__42__;

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__6__;

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__7__;

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__8__;

/***/ }),

/***/ 95:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(96);


/***/ }),

/***/ 96:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.batchUtil = exports.odata = exports.http = void 0;

var odata = _interopRequireWildcard(__webpack_require__(97));

var http = _interopRequireWildcard(__webpack_require__(98));

var batchUtil = _interopRequireWildcard(__webpack_require__(103));

exports.batchUtil = batchUtil;

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

var httpWithDelete = {
  signature: http.signature,
  ajax: http.ajax,
  defaults: http.defaults,
  xhr: http.xhr,
  get: http.get,
  post: http.post,
  put: http.put,
  patch: http.patch,
  delete: http.$delete
};
exports.http = httpWithDelete;
var odataWithDelete = {
  defaults: odata.defaults,
  get: odata.get,
  post: odata.post,
  put: odata.put,
  patch: odata.patch,
  delete: odata.$delete,
  ajax: odata.ajax,
  batch: odata.batch,
  upload: odata.upload
};
exports.odata = odataWithDelete;

/***/ }),

/***/ 97:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaults = defaults;
exports.post = post;
exports.upload = upload;
Object.defineProperty(exports, "ajax", {
  enumerable: true,
  get: function get() {
    return _odataCore.default;
  }
});
Object.defineProperty(exports, "batch", {
  enumerable: true,
  get: function get() {
    return _odataBatch.default;
  }
});
exports.$delete = exports.patch = exports.put = exports.get = void 0;

var _underscore = _interopRequireDefault(__webpack_require__(7));

var core = _interopRequireWildcard(__webpack_require__(98));

var _odataCore = _interopRequireDefault(__webpack_require__(101));

var _odataBatch = _interopRequireDefault(__webpack_require__(102));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function defaults(defaultOptions) {
  return function () {
    var args = [];

    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }

    var _a = core.signature(args),
        url = _a[0],
        options = _a[1],
        cb = _a[2];

    var op = _underscore.default.defaults({}, options, defaultOptions);

    return (0, _odataCore.default)(url, op, cb);
  };
}

var get = defaults({
  method: 'GET'
});
exports.get = get;
var put = defaults({
  method: 'PUT'
});
exports.put = put;
var patch = defaults({
  method: 'PATCH'
});
exports.patch = patch;
var $delete = defaults({
  method: 'DELETE'
});
exports.$delete = $delete;

function post() {
  var args = [];

  for (var _i = 0; _i < arguments.length; _i++) {
    args[_i] = arguments[_i];
  }

  var _a = core.signature(args),
      url = _a[0],
      options = _a[1],
      cb = _a[2];

  var op = _underscore.default.defaults({}, options, {
    method: 'POST',
    xhr: function xhr() {
      var xhr = core.xhr();

      if (options.progress && xhr.upload) {
        xhr.upload.addEventListener('progress', options.progress, false);
      }

      return xhr;
    }
  });

  return (0, _odataCore.default)(url, op, cb);
} // upload using FormData with content-type multipart/form-data.
// FormData is not avaiable until IE 10.


function upload() {
  var args = [];

  for (var _i = 0; _i < arguments.length; _i++) {
    args[_i] = arguments[_i];
  }

  var _a = core.signature(args),
      url = _a[0],
      options = _a[1],
      cb = _a[2];

  var op = _underscore.default.defaults({}, options, {
    data: new FormData(),
    contentType: false,
    processData: false
  });

  op.data.append('file', options.file);
  return post(url, op, cb);
}

/***/ }),

/***/ 98:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.signature = signature;
exports.ajax = ajax;
exports.defaults = defaults;
exports.xhr = xhr;
exports.$delete = exports.patch = exports.put = exports.post = exports.get = void 0;

var _underscore = _interopRequireDefault(__webpack_require__(7));

var _jquery = _interopRequireDefault(__webpack_require__(99));

var _bluebird = _interopRequireDefault(__webpack_require__(6));

var safeJSON = _interopRequireWildcard(__webpack_require__(13));

var _url = __webpack_require__(100);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultOptions = {
  contentType: 'application/json',
  dataType: 'json',
  cache: false,
  type: 'GET'
};

function getResponseHeaders(xhrObject) {
  var ret = {};
  var str = xhrObject.getAllResponseHeaders();
  var arr = str && str.split('\r\n');
  var reg = /^([^:]*): (.*)$/;

  _underscore.default.each(arr, function (header) {
    // sample header: 'key: value'
    var matches = header.match(reg);

    if (matches) {
      var key = matches[1],
          value = matches[2];
      ret[key] = value;
    }
  });

  return ret;
}

function stringify(data, _a) {
  var method = _a.method,
      contentType = _a.contentType;

  if (!method || method === 'GET') {
    return undefined;
  }

  if (!_underscore.default.isString(data) && contentType === 'application/json') {
    return JSON.stringify(data);
  }

  return data;
}

function signature() {
  var originalArgs = [];

  for (var _i = 0; _i < arguments.length; _i++) {
    originalArgs[_i] = arguments[_i];
  }

  var arg = originalArgs;

  if (_underscore.default.isArray(originalArgs[0])) {
    arg = originalArgs[0];
  } else if (_underscore.default.isArguments(originalArgs[0])) {
    arg = _underscore.default.toArray(originalArgs[0]);
  }

  var first = arg[0],
      second = arg[1],
      third = arg[2];

  if (_underscore.default.isObject(first)) {
    // options is first arg
    return [first.uri || first.url || '', first, second];
  } else if (_underscore.default.isFunction(second)) {
    // url is string, but options is omited
    return [first, {}, second];
  }

  return [first, second, third];
}

function ajax() {
  var args = [];

  for (var _i = 0; _i < arguments.length; _i++) {
    args[_i] = arguments[_i];
  }

  var _a = signature(args),
      url = _a[0],
      _b = _a[1],
      customAjax = _b.customAjax,
      method = _b.method,
      xhrFields = _b.xhrFields,
      _success = _b.success,
      _error = _b.error,
      data = _b.data,
      customParamSerialize = _b.customParamSerialize,
      urlParameters = _b.urlParameters,
      contentType = _b.contentType,
      dataType = _b.dataType,
      converters = _b.converters,
      cache = _b.cache,
      beforeSend = _b.beforeSend,
      complete = _b.complete,
      bypassAjaxLogging = _b.bypassAjaxLogging,
      processData = _b.processData,
      xhrOption = _b.xhr,
      parse = _b.parse,
      i18nErrors = _b.i18nErrors,
      headers = _b.headers,
      timeout = _b.timeout,
      cb = _a[2];

  var ajaxFunc = customAjax || _jquery.default.ajax; // todo handle upper case method

  var $op = _underscore.default.defaults({
    type: method ? method.toUpperCase() : undefined,
    xhrFields: {
      withCredentials: xhrFields && xhrFields.withCredentials,
      responseType: xhrFields && xhrFields.responseType
    },
    success: function success(response, textStatus, xhrObject) {
      if (_success) {
        _success(response, textStatus, xhrObject);
      }

      if (cb) {
        cb(null, response, textStatus, xhrObject);
      }
    },
    error: function error(xhrObject, textStatus, errorThrown) {
      // NOFIX:
      // If you need this logic, you should wrap options.error to add this in your code
      // if (xhr && xhr.status === 401) {
      //   state.trigger('http.auth.error');
      // }
      if (_error) {
        _error(xhrObject, textStatus, errorThrown);
      }

      var details = {
        xhr: xhrObject,
        textStatus: textStatus,
        error: errorThrown,
        headers: getResponseHeaders(xhrObject)
      };
      safeJSON.parse(xhrObject.responseText, function (err, res) {
        if (err) {
          if (cb) {
            cb(_underscore.default.extend(new Error('could not parse error'), details));
          }

          return;
        }

        details.body = res;

        if ($op.parse) {
          details.errors = $op.parse(res);
        }

        if ($op.i18nErrors && details.errors) {
          details.i18nErrors = $op.i18nErrors;
        }

        if (cb) {
          cb(details);
        }
      });
    }
  }, {
    contentType: contentType,
    dataType: dataType,
    converters: converters,
    cache: cache,
    beforeSend: beforeSend,
    complete: complete,
    bypassAjaxLogging: bypassAjaxLogging,
    processData: processData,
    xhr: xhrOption,
    parse: parse,
    i18nErrors: i18nErrors,
    headers: headers,
    timeout: timeout
  }, defaultOptions);

  $op.url = (0, _url.queryify)(url, {
    method: method,
    data: data,
    customParamSerialize: customParamSerialize,
    urlParameters: urlParameters
  });
  $op.data = stringify(data, {
    method: method,
    contentType: contentType
  });
  return _bluebird.default.resolve(ajaxFunc($op)).catch(function (err) {
    var extraInfo = {
      body: safeJSON.parseSync(err.responseText),
      headers: getResponseHeaders(err)
    };

    if ($op.parse && extraInfo.body) {
      extraInfo.errors = $op.parse(extraInfo.body);
    }

    if ($op.i18nErrors && extraInfo.errors) {
      extraInfo.i18nErrors = $op.i18nErrors;
    }

    throw _underscore.default.extend(err, extraInfo);
  });
}

function defaults(defaultOps) {
  return function wrappedAjax() {
    var originalArgs = [];

    for (var _i = 0; _i < arguments.length; _i++) {
      originalArgs[_i] = arguments[_i];
    }

    var _a = signature(originalArgs),
        url = _a[0],
        options = _a[1],
        cb = _a[2];

    var op = _underscore.default.defaults({}, options, defaultOps);

    return ajax(url, op, cb);
  };
}

function xhr() {
  return _jquery.default.ajaxSettings.xhr();
}

var get = defaults({
  method: 'GET'
});
exports.get = get;
var post = defaults({
  method: 'POST'
});
exports.post = post;
var put = defaults({
  method: 'PUT'
});
exports.put = put;
var patch = defaults({
  method: 'PATCH'
}); // delete is a reserved keyword

exports.patch = patch;
var $delete = defaults({
  method: 'DELETE'
});
exports.$delete = $delete;

/***/ }),

/***/ 99:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__99__;

/***/ })

/******/ });
});
